export default __webpack_public_path__ + "static/media/searchicon.45e69cd6.png";